import styled from 'styled-components';

export default styled.div`
	padding-bottom: var(--px-50);
	.section-header {
		display: flex;
		flex-direction: column;
		color: var(--neutrals-900) !important;
	}
`;
